import { connect } from 'react-redux';
import Contact from './Contact';

import { updateRoute, activateTransition } from 'redux/actions';

const mapStateToProps = state => ({
  transitionActive: state.app.transitionActive,
});

const mapDispatchToProps = {
  updateRoute,
  activateTransition,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Contact);
